import TYPES from '../../types';

// Domain
import { KuspitEarningsReportEntity } from '../../domain/entities/kuspit-earnings-report-entity';
import {
  KuspitEarningsReportRepository,
} from '../../domain/repository/kuspit-earnings-report-repository';
import Injectable from '@/modules/shared/domain/di/injectable';
import Inject from '@/modules/shared/domain/di/inject';
import Query from '@/modules/shared/domain/use-cases/query';

@Injectable()
export default class SearchKuspitEarningsReportQuery
  extends Query<Promise<Array<KuspitEarningsReportEntity>>> {
  @Inject(TYPES.KUSPIT_EARNINGS_REPORT_REPOSITORY)
  private readonly repository!: KuspitEarningsReportRepository;

  internalExecute(): Promise<Array<KuspitEarningsReportEntity>> {
    return new Promise((resolve, reject) => {
      this.repository.get()
        .then((items) => {
          resolve(items);
        })
        .catch(reject);
    });
  }
}
